import { useState } from 'react';
import usePageMeta from '../lib/usePageMeta';
import PageHero from '../components/PageHero';
import { PostCard } from '../components/Blocks';
import { POSTS } from '../data';

const CATS = ['All', ...Array.from(new Set(POSTS.map((p) => p.cat)))];

export default function Blog() {
  usePageMeta('Blog', 'Articles on web development, mobile apps, design, animation, SEO and DevOps from the Origo Private Limited team.');
  const [cat, setCat] = useState('All');
  const list = POSTS.filter((p) => cat === 'All' || p.cat === cat);

  return (
    <>
      <PageHero
        eyebrow="Insights"
        title="Ideas, guides and lessons from the team"
        description="Practical articles on building and growing digital products — written by the specialists doing the work."
        crumbs={[{ label: 'Blog' }]}
      />
      <section className="section bg-brand-soft">
        <div className="container-x">
          <div className="flex flex-wrap justify-center gap-2" data-anim="up">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} className={`rounded-full px-5 py-2 text-sm font-semibold transition-all ${cat === c ? 'bg-brand text-white shadow-lg' : 'bg-white text-brand hover:bg-brand/10'}`}>{c}</button>
            ))}
          </div>
          <div key={cat} className="mt-12 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
            {list.map((p) => <PostCard key={p.slug} post={p} />)}
          </div>
        </div>
      </section>
    </>
  );
}
